import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import IconButton from '@mui/material/IconButton';
import MatButton from '@mui/material/Button';
import MUIDataTable from "mui-datatables";
import { Table } from 'reactstrap';

// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {
	FormGroup,
	Label,
	Input,
} from 'reactstrap';

import ConfirmationDialog from "Routes/common/ConfirmationDialog";

import {
   allFindingChart,
   addFindingChart,
   editFindingChart,
   deleteFindingChart,
   fetchFindingChart,
   uploadFindingReports,
   fetchFindingReports,
   deleteFindingReports,
   updateFindingReports
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import AddMSKElement from './component/addfind';
import EditMSKElement from'./component/editfind';

class mskfindingchart extends Component {
   
   constructor(props) {
      
      super(props);
        this.confirmationDialog = React.createRef();
         this.state = {
            viewdiv:true,
            adddiv:false,
            editdiv:false,
            reportdiv:false,
            eid:'',
            edname:'',
            eddesignation:'',
            edemail:'',
            edmobile:'',
            sfcid:'',
            selectedFile:''
         };      
      this.addHandleSubmit = this.addHandleSubmit.bind(this); 
      this.deleteAssessment = this.deleteAssessment.bind(this); 
      this.editTeam = this.editTeam.bind(this);
      this.editHandleSubmit = this.editHandleSubmit.bind(this);
      this.onBackSection = this.onBackSection.bind(this);
      this.editAssessment = this.editAssessment.bind(this);
      this.onFileChange = this.onFileChange.bind(this);
      
   }

   UNSAFE_componentWillMount() {
		this.props.allFindingChart('');
	}
   
   addHandleSubmit(event) {
      event.preventDefault();
      this.props.addFindingChart(event).then((data) => {   
           
        if(data.status==1){
                
                document.getElementById("ssteamform").reset();
        }
    });
      
   }

   editAssessment(rowid){
      
      this.props.fetchFindingChart(rowid).then((data) => {   
         var resdata=data.data;
         
         this.setState({ 
            viewdiv:false,
            adddiv:false,
            editdiv:true
             });
      });
      
   }

   onAddSession() {
		this.setState({ 
         viewdiv:false,
         editdiv:false,
         adddiv:true
          });
	}   

   deleteAssessment(data){
        this.data = data;
        this.confirmationDialog.current.openDialog();
    }

    deleteDataPermanent(popupResponse){
        
        if (popupResponse) {
            this.props.deleteFindingChart(this.data);
            this.data = ""
        }
    }

   editTeam(rawdata){    
      this.setState({
         eid:rawdata.sctID,
         edname:rawdata.sc_name,        
         eddesignation:rawdata.sc_designation,        
         edemail:rawdata.sc_email,        
         edmobile:rawdata.sc_phone,        
         adddiv:false,
         editdiv:true
      });
   }

   editHandleSubmit(event) {
      event.preventDefault();
      this.props.editFindingChart(event,this.state.eid);      
   }   

   onBackSection() {
		this.setState({ 
         adddiv:false,
         editdiv:false,
         reportdiv:false,
         viewdiv:true });
	}

   UpdateAssessment(rowid){
      
      this.props.fetchFindingReports(rowid).then((data) => {            
         this.setState({ 
            sfcid:rowid,
            viewdiv:false,
            adddiv:false,
            editdiv:false,
            reportdiv:true
             });
      });
      
   }

   reportHandleSubmit(event){
         event.preventDefault();
         let selectedFile = this.state.selectedFile;
         this.props.uploadFindingReports(event, selectedFile);
         
   }

   onFileChange(event){
         const file = event.target.files[0];
         const base64 = this.convertBase64(file).then(result => this.setState({
            selectedFile: result
         }));
      
   };

   convertBase64 = (file) => {
         return new Promise((resolve, reject) => {
         const fileReader = new FileReader();
         fileReader.readAsDataURL(file)
         fileReader.onload = () => {
            resolve(fileReader.result);
         }
         fileReader.onerror = (error) => {
            reject(error);
         }
         })
   }

   reportUpdateSubmit(event){
         event.preventDefault();
         this.props.updateFindingReports(event);
         
   }

   deleteFile(rowid,scid){
         if(window.confirm('Are you sure to delete this report?')){          
            this.props.deleteFindingReports(rowid,scid);    
         }
         
   }

    render() {
       const { match, findchartlists, findingreportlists, loading } = this.props;
       const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            responsive:'standard',
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
        };

        const columns = [
            { name: "no", label: "No" },
            { name: "name", label: "Name" },
            { name: "date", label: "Date" },
            { name: "report", label: "Report Upload" },
            { name: "edit", label: "Edit" },
            { name: "delete", label: "Delete" }
        ];
        const tabledata=findchartlists.map((assmntval,idx) => {            
            
                const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval.sfcID)}><EditOutlinedIcon/></IconButton>;
                const dbtn=<IconButton className="text-danger" aria-label="Delete" onClick={ ()=>this.deleteAssessment(assmntval.sfcID)}><DeleteOutlineOutlinedIcon/></IconButton>;
                const upbtn=<MatButton variant="contained" onClick={ ()=>this.UpdateAssessment(assmntval.sfcID)} className="btn-info mr-3 mb-3 btn-sm text-white">Report</MatButton>;
                return {
                no:idx+1,
                name: assmntval.student,
                date: assmntval.cdate,
                report: upbtn,
                edit: ebtn,
                delete:dbtn
                }
        });
       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>MSK Finding Chart | {AppConfig.appTitle}</title>
                <meta name="description" content="Sport Science Team" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.mskfindingheading" />} match={match} />
            
              {this.state.viewdiv && 
                  <div className="col-sm-12 col-lg-8" style={{margin:"0 auto"}}>
                     <RctCollapsibleCard heading="List" fullBlock>
                        <MUIDataTable
                              title={<div><Button onClick={ ()=>this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Create MSK Finding </Button></div>}
                              data={tabledata}
                              columns={columns}
                              options={options} 
                        />   
                     </RctCollapsibleCard>
                  </div>  
               } 
               {this.state.adddiv && 
                  <AddMSKElement onClick={this.onBackSection}/>
               }

               {this.state.editdiv && 
                  <EditMSKElement onClick={this.onBackSection} data={this.state}/>
               }

               {this.state.reportdiv && 
                  <div className="col-sm-12 col-lg-8">
                           <RctCollapsibleCard heading="Reports">  
                              <div className="table-responsive">
                                 <Table hover bordered striped>
                                       <thead>
                                          <tr className="bg-primary text-white">
                                             <th>Sl.No</th>
                                             <th>Name</th>
                                             <th>Action</th>
                                          </tr>
                                       </thead>
                                       <tbody>                              
                                       {findingreportlists.map((fleval,idx) => (
                                          <tr key={idx}>
                                             <td>{idx + 1}</td>
                                             <td><form autoComplete="off" className="form-horizontal form-validate form-inline" onSubmit={(e)=>this.reportUpdateSubmit(e)}> 
                                                      <input type="text" name="updname" className="form-control form-control-alternative" defaultValue={fleval.sir_reportname} key={fleval.sir_reportname} required/>
                                                      <input type="hidden" name="eid" id="eid" value={fleval.sirID}></input>
                                                      <input type="submit" className="MuiButtonBase-root MuiButton-root MuiButton-text text-warning mr-3 mb-3" value="update" />
                                                   </form>    
                                             </td>
                                             <td>
                                             <a href={AppConfig.apiurl+'/theme/img/findings/'+fleval.sir_filename} target="_blank"><span className="badge badge-info" >View</span></a>
                                             <IconButton className="text-danger" aria-label="Delete" onClick={ ()=>this.deleteFile(fleval.sirID,fleval.sicID)}><DeleteOutlineOutlinedIcon/></IconButton> 
                                             </td>
                                          </tr>
                                       ))}                                                                
                                       </tbody>
                                 </Table>
                              </div>
                              <form autoComplete="off" id="editassessmentform" onSubmit={(e)=>this.reportHandleSubmit(e)}> 
                                       <div className="form-group">
                                          <FormGroup>
                                             <Label for="Select">Report Name</Label>
                                             <input type="text" name="reportname" id="reportname" className="form-control form-control-alternative" required/>
                                          </FormGroup>  
                                       </div>
                                       <div className="form-group">
                                       <FormGroup>
                                          <Label for="Select">Upload Reports</Label>
                                          <input type="file" name="fileupl" id="fileupl" onChange={this.onFileChange} className="form-control form-control-alternative" required/>
                                       </FormGroup>  
                                       </div>
                                       <div className="form-group">
                                          <input type="hidden" name="eid" id="eid" value={this.state.sfcid}></input>
                                          <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />
                                          <input type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.onBackSection} value="Back" />
                                       </div>                                           
                              </form>
                           </RctCollapsibleCard>      
                  </div> 
               }
            
             <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'findings chart'}
            />
          </div>
       )
    }
 }




const mapStateToProps = ({ findingchart }) => {
	const { findchartlists, findingreportlists, loading } = findingchart;
	return { findchartlists, findingreportlists, loading };
}

export default connect(mapStateToProps, {
    allFindingChart,
    addFindingChart,
    editFindingChart,
    deleteFindingChart,
    fetchFindingChart,
    uploadFindingReports,
    fetchFindingReports,
    deleteFindingReports,
    updateFindingReports
})(mskfindingchart); 